import { css } from '@/styled-system/css';

export const moduleContainer = css({
  paddingTop: '4x',
  paddingBottom: '4x',
  backgroundColor: 'hpxWhite',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'rgba(209, 209, 214, 0.50)',
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
  overflow: 'hidden',
  '&:has(> [data-module-content]:empty)': {
    display: 'none',
  },
});

export const moduleTitle = css({
  fontSize: 'lg', // 20px font size
  lineHeight: 'lg', // 24px line height
  color: 'hpxBlue500', // Title color as specified
  fontWeight: 'bold',
  margin: '0', // Reset default heading margins
  padding: '0', // Reset default heading padding
});

export const moduleContent = css({
  display: 'flex',
  flexDirection: 'column',
  flex: '1', // Take up available space between title and footer
});

export const moduleFooter = css({
  display: 'flex',
  flexDirection: 'column',
  marginTop: 'auto', // Push footer to bottom if needed
});
